<template>
  <div class="home">
    <AppMain :appEditionLog="appEditionLog" :appInfo="appInfo" />
  </div>
</template>

<script>
import AppMain from "./components/AppMain";
import { getEditionInfo } from "@/api/common";
import { isIos } from "@/utils/";

export default {
  components: {
    AppMain,
  },
  data() {
    return {
      appEditionLog: {},
      appInfo: {
        name: "慕思助手APP下载",
        appLogo:
          "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/dlogo.png",
        guide: [
          "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/step1.jpg",
          "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/step2.jpg",
          "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/step3.jpg",
          "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/step4.jpg",
          "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/appdownload/step5.jpg",
        ],
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {
    document.title = "慕思助手APP下载";
  },
  methods: {
    asIOS() {
      return this.$route.query.plat === "ios" || isIos;
    },
    init() {
      getEditionInfo({
        type: "慕思助手app",
        platform: this.asIOS() ? "iOS" : "Android",
      }).then((res) => {
        const id = this.$route.query.id;
        if (id && res.history.some((item) => id == item.id)) {
          for (const item of res.history) {
            if (id == item.id) {
              this.appEditionLog = item;
            }
          }
        } else {
          this.appEditionLog = res.appEditionLog;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
